import React from 'react';
import { useTranslation } from 'react-i18next';

import { View } from 'components/layout/View';
import Text from 'components/outputs/Text';

// Leading "1. " / "2)" style ordinal, with any trailing whitespace.
const ORDINAL_PREFIX = /^\s*\d+[.)]\s*/;

// Numbered badge beside a step title, so the ordinal is a visual element rather
// than a "1. " prefix baked into every translation. Ported from the numbered
// step headings in wallet-react-native's MfaToken.
export default function StepHeading({ number, id, children }) {
  const { t } = useTranslation(['common']);
  // Tenant-supplied locales override the bundled strings (see
  // util/i18n/provider.js), so a company still translating the old "1. Scan the
  // QR code" would otherwise render its number twice next to the badge. Strip
  // the prefix only when one is actually present, so the normal path keeps
  // Text's own id resolution and missing-key fallback.
  const resolved = id ? t(id, { defaultValue: '' }) : '';
  const stripped = resolved.replace(ORDINAL_PREFIX, '');
  const hasPrefix = Boolean(resolved) && stripped !== resolved;

  return (
    <View fD={'row'} aI={'center'} w={'100%'}>
      <View
        w={24}
        h={24}
        bR={12}
        bC={'primary'}
        aI={'center'}
        jC={'center'}
        style={{ flexShrink: 0 }}>
        <Text s={14} bold tA={'center'} c={'primaryContrast'}>
          {number}
        </Text>
      </View>
      <View pl={0.5} w={'100%'}>
        <Text component="h2" bold id={hasPrefix ? undefined : id}>
          {hasPrefix ? stripped : children}
        </Text>
      </View>
    </View>
  );
}
